<template>
  <v-form
      v-model="valid"
      ref="form"
      lazy-validation
  >
    <v-text-field
        v-model="details.firstname"
        required
        :rules="rules.firstname"
        label="First name"
        outlined
    ></v-text-field>
    <v-text-field
        v-model="details.middlename"
        label="Middle name"
        outlined
    ></v-text-field>
    <v-text-field
        v-model="details.lastname"
        required
        :rules="rules.lastname"
        label="Last name"
        outlined
    ></v-text-field>
    <v-radio-group
        class="mt-0"
        row
        v-model="details.gender"
        required
        :rules="rules.gender"
    >
      <v-radio value="M" label="Male"/>
      <v-radio value="F" label="Female"/>
    </v-radio-group>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value="details.birthdate"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
            v-model="details.birthdate"
            required
            :rules="rules.birthdate"
            label="Date of birth"
            placeholder="YYYY-DD-MM"
            prepend-icon="mdi-calendar"
            outlined
            v-on="on"
            readonly
        ></v-text-field>
      </template>
      <v-date-picker
          ref="picker"
          v-model="details.birthdate"
          :active-picker.sync="activePicker"
          :max="new Date().toISOString().substr(0, 10)"
          min="1910-01-01"
          @change="$refs.menu.save(details.birthdate)"
      ></v-date-picker>
    </v-menu>
    <v-autocomplete
        label="Nationality"
        v-model="details.nationality"
        :items="countries"
        item-text="display_name"
        item-value="value"
        required
        :rules="rules.nationality"
        prepend-icon="mdi-earth"
        outlined
    ></v-autocomplete>
    <v-autocomplete
        label="Residency"
        v-model="details.residency"
        :items="countries"
        item-text="display_name"
        item-value="value"
        required
        :rules="rules.residency"
        prepend-icon="mdi-home"
        outlined
    ></v-autocomplete>
    <v-file-input
        label="Passport Scan"
        show-size
        ref="passportFile"
        @change="attachPassport($event)"
        :rules="rules.passport"
        prepend-icon="mdi-paperclip"
        outlined
    ></v-file-input>
    <v-file-input
        ref="birthcertificateFile"
        :rules="rules.birthcertificate"
        label="Birth Certificate Translation Scan"
        outlined
        prepend-icon="mdi-paperclip"
        show-size
        @change="attachBirthCertificate($event)"
    ></v-file-input>
    <v-textarea
        label="Permanent Address"
        v-model="details.address"
        :rules="rules.address"
        prepend-icon="mdi-map-marker"
        outlined
        auto-grow
        rows="1"
    />
    <v-checkbox
        v-model="details.is_spelling_confirmed"
        :rules="rules.is_spelling_confirmed"
        class="mt-0"
        dense
        hide-details
    >
      <template v-slot:label>
        <div>
          I confirm that the <strong>applicant's name entered as per birth certificate translation</strong> and
          confirmed
          with the investor for the spelling of the full name.
        </div>
      </template>
    </v-checkbox>
  </v-form>
</template>
<script>

import {errorNotification} from "@/components/utils";

export default {
  components: {},
  directives: {},
  name: 'ApplicantForm',
  props: {
    value: Object,
  },
  data() {
    return {
      menu: false,
      activePicker: null,
      valid: false,
      passportFile: '',
      birthcertificateFile: '',
      countries: [],
      details: this.value
    }
  },
  computed: {
    rules() {
      let rules = {
        firstname: [
          v => !!v || 'First name is required',
        ],
        lastname: [
          v => !!v || 'Last name is required',
        ],
        gender: [
          v => !!v || 'Gender is required',
        ],
        birthdate: [
          v => !!v || 'Date of Birth is required',
          v => /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/.test(v) || 'Date supposed to be in ISO format, e.g. ' + new Date().toISOString(),
        ],
        nationality: [
          v => !!v || 'Nationality is required',
        ],
        residency: [
          v => !!v || 'Residency is required',
        ],
        address: [
          v => !!v || 'Address is required',
        ],
        is_spelling_confirmed: [
          v => !!v || 'Confirmation of spelling is required',
          // v => v !== true || 'Confirmation of spelling is required',
        ],
        passport: [
          v => !!v || 'Passport scan is required',
        ],
        birthcertificate: [
          v => !!v || 'Birth Certificate Translation is required',
        ],
      }
      if (this.value.passport !== null) {
        rules['passport'] = [
          v => (v.size < (2621440 * 10)) || 'Passport file size should be less than 25 MB!'
        ]
      }
      if (this.value.birthcertificate !== null) {
        rules['birthcertificate'] = [
          v => (v.size < (2621440 * 10)) || 'Passport file size should be less than 25 MB!'
        ]
      }
      return rules
    }
  },
  mounted() {
    this.fetchOptions()
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    details: {
      deep: true,
      handler() {
        this.updateDetails()
      }
    }
  },
  methods: {
    fetchOptions() {
      // Fetch possible options
      this.$axios.options('/applicants/')
          .then((response) => {
            this.options = response.data
            this.countries = this.options.actions.POST.nationality.choices
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    attachPassport(file) {
      this.$set(this.details, 'passport', file)
    },
    attachBirthCertificate(file) {
      this.$set(this.details, 'birthcertificate', file)
    },
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.resetValidation()
      this.$refs.form.reset()
    },
    updateDetails() {
      this.$emit('input', this.details)
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  }
}
</script>